import React from "react";
import { TouchableOpacity, View, TextInput, StyleSheet } from "react-native";
import styles from "@screens/YourStore/yourStoreStyle";
import BackArrow from "@assets/svg/BackArrow";
import { isSmallScreen } from "@constants/metrics";
import { useNavigation } from "@react-navigation/native";
import { default as SearchIcon } from "../assets/svg/Search";
import { default as CrossIcon } from "../assets/svg/Cross";
import testIds from "@constants/testIds";

const SearchBar = (
  {
    customStyles = {},
    placeholder = "",
    query = "",
    handleQueryChange = (e) => {},
    shouldShowIcon = false,
    autoFocus = false,
    onPressRightIcon = () => {},
    disabled = false,
    backBtn = false,
    clearSearch = false,
    testID,
    onFocus,
  },
  ref,
) => {
  const navigation = useNavigation();
  return (
    <View
      style={[
        {
          flexDirection: "row",
          alignItems: "center",
        },
        customStyles,
      ]}
    >
      {backBtn && (
        <TouchableOpacity
          onPress={() => {
            navigation.goBack();
          }}
          style={{
            alignItems: "center",
            paddingRight: 6,
          }}
        >
          <BackArrow />
        </TouchableOpacity>
      )}
      <View style={styles.searchBar}>
        {shouldShowIcon && (
          <TouchableOpacity
            onPress={onPressRightIcon}
            style={styles.searchIconContainer}
          >
            <SearchIcon />
            {/* {clearSearch && query.length === 0 && <SearchIcon />}
            {!clearSearch && <SearchIcon />} */}
          </TouchableOpacity>
        )}
        <TextInput
          placeholderTextColor="rgba(0, 0, 0, 0.36)"
          placeholder={placeholder}
          style={styles.searchInput}
          value={query}
          onChangeText={(value) => handleQueryChange(value)}
          autoFocus={autoFocus}
          disabled={disabled}
          clearButtonMode="always"
          testID={testID}
          ref={ref}
          onFocus={onFocus}
        />

        {shouldShowIcon && query.length > 0 && clearSearch && (
          <TouchableOpacity
            onPress={onPressRightIcon}
            style={[styles.searchIconContainer, { opacity: 0.86, padding: 25 }]}
          >
            <CrossIcon height={11} width={11} />
          </TouchableOpacity>
        )}
      </View>
    </View>
  );
};

const forwardingSearchBar = React.forwardRef(SearchBar);

export default forwardingSearchBar;
